import {
	db,
	DEBUG,
	IEventable,
	IModel,
	IVIPCertificateBase,
	IVIPCertificatePdf,
	IEventInfo,
	VIPCertificateBase,
	VIPCertificateEvent,
	VipCertificateStatus,
	VipCertificateType,
	createAbilityCertificateData,
	createWorkCertificateData,
	IVIPCertificateData,
	VIPProject,
	createEventInfo,
	checkAbilityCertificate,
	checkWorkCertificateData,
	VIPIp,
} from "@/loader";
import dayjs from "dayjs";
import { Duration } from "dayjs/plugin/duration";

export function getNextVipCertificateStatus(status: VipCertificateStatus): VipCertificateStatus | null {
	switch (status) {
		case VipCertificateStatus.draft: return VipCertificateStatus.checking;
		case VipCertificateStatus.checking: return VipCertificateStatus.validating;
		case VipCertificateStatus.validating: return VipCertificateStatus.sending;
		case VipCertificateStatus.sending: return VipCertificateStatus.awaiting;
		default: return null;
	}
}

/**
 * Certificate Interface.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export interface IVIPCertificate extends IVIPCertificateBase {
	datas?: IVIPCertificateData;
	ref ?: string;
}

/**
 * Certificate Class.
 *
 * Auto-generated by WP Generator (copyright 86Dev).
 * You can modify it because it will NOT be overwritten by WP Generator.
 *
 * @author		86Dev
 * @version		0.0.0
 * @since		1.0.0
 */
export class VIPCertificate extends VIPCertificateBase implements IVIPCertificate, IModel<IVIPCertificate>, IEventable {
	public datas!: IVIPCertificateData;
	public ref: string = "";

	public event: IEventInfo | null = null;

	public pdf: IVIPCertificatePdf | null = null;

	public get ago(): Duration | null {
		return this.date ? dayjs.duration(this.date.diff(dayjs())) : null;
	}

	/**
	 * Get Certificate events
	 */
	public get events(): VIPCertificateEvent[] {
		return db.certificateEvents.list
			.filter(x => x.fk_certificate === this.id)
			.sort((a, b) => a.event && b.event && b.event.date.diff(a.event.date) || b.fk_event - a.fk_event);
	}

	public get lastEvent(): VIPCertificateEvent | null {
		return this.events?.[0] || null;
	}

	constructor (data: IVIPCertificate = {}) {
		super(data);
	}

	public load(data: IVIPCertificate) {
		super.load(data);

		this.datas = data.datas || JSON.parse(data.data || "{}");
		this.ref = String.orDefault(data.ref);
		this.checkData();
	}

	public update(data: IVIPCertificate) {
		super.update(data);

		if (data.datas !== undefined) {
			this.datas = data.datas;
			this.checkData();
		} else if (data.data !== undefined) {
			this.datas = JSON.parse(data.data || "{}");
			this.checkData();
		}

		if (data.ref !== undefined) {
			this.ref = String.orDefault(data.ref);
		}
	}

	public toString() {
		return [this.getTypeLabel(), this.project?.name].filter(x => !!x).join(" ");
	}

	public documentUrl(token: string) {
		return `/?certificate=${this.id}&signed=${this.isSigned ? "yes" : "no"}&token=${token}`;
	}

	public checkData() {
		if (this.isTypeAbilityCertificate) {
			checkAbilityCertificate(this.datas, this.project);
		} else {
			checkWorkCertificateData(this.datas, this.project);
		}
	}

	public hasIP(ip: VIPIp | number): boolean {
		return this.ips.some(x => x.fk_ip === ip || x.ip === ip);
	}
}

export function getCertificateData(type: VipCertificateType, project: VIPProject): IVIPCertificate {
	let data: IVIPCertificate = {
		fk_project: project.id,
		type,
		status: VipCertificateStatus.draft,
		datas: type === VipCertificateType.workCertificate ? createWorkCertificateData(project) : createAbilityCertificateData(project),
		event: createEventInfo(),
	};
	data.data = JSON.stringify(data.datas);
	return data;
}
